import { OfflineImage } from "../../../assets/svgImages";
import primaryComponents from "../../primaryComponents";

export const LocalSetupRoutePopup = ({ onlinePath }) => {
  return (
    <div className="d-flex flex-column p-3" style={{ gap: "30px" }}>
      <div>
        <h4>Unavailable for Offline Mode</h4>
        <hr />
      </div>

      <OfflineImage />
      <div>
        <h5>You can&apos;t use this feature on offline mode at the moment</h5>
        <p>Kindly click the button below to perform this task online</p>
      </div>

      <primaryComponents.Button
        classNames={"btn btn--primary cover"}
        onClick={() => {
          window.open(
            `${process.env.REACT_APP_LUMI_MERCHANT_FRONTEND_APP_BASE_URL}${onlinePath}`,
          );
        }}
      >
        Use Feature Online
      </primaryComponents.Button>
    </div>
  );
};
